import { AfterContentInit, Directive, ElementRef, input } from '@angular/core';

@Directive({
  selector: '[editorAutoFocus]'
})
export class EditorAutoFocusDirective implements AfterContentInit {
  condition = input<boolean>(true);
  block = input<'start' | 'center' | 'end' | 'nearest'>('start');
  animationDelay = input<number>(0);

  constructor(private elementRef: ElementRef) {}

  ngAfterContentInit(): void {
    if (this.condition()) {
      setTimeout(() => {
        const allFocusElements = document.querySelectorAll('[editorAutoFocus]');
        const isFirst = allFocusElements.length === 0 || allFocusElements[0] === this.elementRef.nativeElement;
        if (isFirst) {
          this.elementRef.nativeElement.focus();
          this.elementRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: this.block() });
        }
      }, this.animationDelay());
    }
  }
}
